import { Link } from 'react-router-dom';
import { MenuItem } from '../../types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { classNames } from '../../../../../../helper/classNames';
import useMenu from '../../../../../../hooks/useMenu';

type MenuItemLinkProps = {
  item: MenuItem;
  isSelected: boolean;
};

function MenuItemLink({ item, isSelected }: MenuItemLinkProps) {
  const { setClosed } = useMenu();
  return (
    <Link to={item.link} onClick={setClosed}>
      <div
        className={classNames(
          'p-3 flex flex-row justify-start items-center gap-5',
          isSelected ? 'bg-orange-400 text-white' : 'hover:bg-gray-200'
        )}
      >
        {item.icon && <FontAwesomeIcon icon={item.icon} size="lg" />}
        {item.title}
      </div>
    </Link>
  );
}

export default MenuItemLink;
